(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */
  var toggle = document.querySelector('.menu-toggle');
  var menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }
    });
  }

  /* ---------- Apparition au défilement ---------- */
  var reveals = document.querySelectorAll('.reveal');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Galerie produit (vignettes + flèches) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.js-gallery-main img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    function show(i) {
      if (!main || !thumbs.length) return;
      i = (i + thumbs.length) % thumbs.length;
      var btn = thumbs[i];
      main.removeAttribute('srcset');
      main.src = btn.getAttribute('data-src');
      main.alt = btn.getAttribute('data-alt') || '';
      thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
      if (btn.scrollIntoView) btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    function current() {
      var idx = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      return idx < 0 ? 0 : idx;
    }
    thumbs.forEach(function (btn, i) { btn.addEventListener('click', function () { show(i); }); });
    gallery.querySelectorAll('[data-gallery-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(current() + parseInt(b.getAttribute('data-gallery-step'), 10)); });
    });
    gallery.__show = function (src) {
      var name = function (u) { return (u || '').split('?')[0].split('/').pop(); };
      var i = thumbs.findIndex(function (t) { return src && name(t.getAttribute('data-src')) === name(src); });
      if (i >= 0) show(i); else if (main && src) { main.removeAttribute('srcset'); main.src = src; }
    };
  });

  /* ---------- Formulaire produit : quantité, variantes, packs ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = form.querySelector('input[name="quantity"]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10);
        input.value = Math.max(1, next);
      });
    });

    var section = form.closest('[data-section]') || document;
    var currency = form.getAttribute('data-currency') || 'EUR';
    var fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: currency });
    var money = function (c) { return fmt.format(c / 100); };

    var variants = [];
    var dataEl = form.querySelector('[data-variants]');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = section.querySelector('[data-price-current]');
    var compareEl = section.querySelector('[data-price-compare]');
    var badgeEl = section.querySelector('[data-price-badge]');

    function currentVariant() {
      var id = idInput ? parseInt(idInput.value, 10) : null;
      return variants.find(function (v) { return v.id === id; }) || variants[0];
    }

    /* Packs */
    var bundle = form.querySelector('[data-bundle]');
    var bundleQty = form.querySelector('[data-bundle-quantity]');
    function updateBundles(v) {
      if (!bundle || !v) return;
      bundle.querySelectorAll('.bundle__opt').forEach(function (opt) {
        var input = opt.querySelector('input');
        var n = parseInt(input.getAttribute('data-bundle-qty'), 10);
        var pct = parseInt(input.getAttribute('data-bundle-pct'), 10) || 0;
        var unitRef = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
        var total = Math.floor(v.price * n * (100 - pct) / 100);
        var tEl = opt.querySelector('[data-bundle-total]');
        var cEl = opt.querySelector('[data-bundle-compare]');
        if (tEl) tEl.textContent = money(total);
        if (cEl) cEl.textContent = money(unitRef * n);
        opt.classList.toggle('is-selected', input.checked);
      });
    }
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        var input = e.target.closest('input[name="bundle"]');
        if (!input) return;
        if (bundleQty) bundleQty.value = input.getAttribute('data-bundle-qty');
        updateBundles(currentVariant());
      });
    }

    /* Variantes (pastilles) */
    var optionSets = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(v.compare_at_price); }
      if (badgeEl) badgeEl.hidden = !onSale;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      }
      updateBundles(v);
      var gallery = section.querySelector('[data-gallery]');
      if (v.featured_image && v.featured_image.src && gallery && gallery.__show) gallery.__show(v.featured_image.src);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    optionSets.forEach(function (set) {
      set.addEventListener('change', function () {
        var chosen = optionSets.map(function (s) {
          var c = s.querySelector('input:checked');
          var label = s.querySelector('[data-option-selected]');
          if (c && label) label.textContent = c.value;
          return c ? c.value : null;
        });
        var v = variants.find(function (x) {
          return chosen.every(function (val, i) { return x.options[i] === val; });
        });
        applyVariant(v);
      });
    });
    updateBundles(currentVariant());
  });

  /* ---------- Date de livraison estimée ---------- */
  document.querySelectorAll('[data-delivery-dates]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (!min || !max) return;
    function addBusinessDays(d, n) {
      var r = new Date(d);
      while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
      return r;
    }
    var now = new Date();
    var opts = { day: 'numeric', month: 'short' };
    var f = new Intl.DateTimeFormat(document.documentElement.lang || 'fr-FR', opts);
    var a = addBusinessDays(now, Math.round(min * 5 / 7));
    var b = addBusinessDays(now, Math.round(max * 5 / 7));
    el.textContent = 'entre le ' + f.format(a) + ' et le ' + f.format(b);
  });

  /* ---------- Préférences cookies (bannière Shopify) ---------- */
  document.querySelectorAll('[data-cookie-prefs]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });
  });
})();
